module.exports = __webpack_public_path__ + "static/media/brandmark.c15d55f6.c15d55f6.png";